import { gql } from '@apollo/client';
import List from './List';
import Show from './Show';
import Edit from './Edit';

export default {
  name: 'pro_pools',
  inputShow: gql`
    query getPool($input: PoolQueryInput) {
      pools(input: $input) {
        id
        location {
          id
        }
      }
    }
  `,
  list: List,
  show: Show,
  edit: Edit,
  options: {
    group: 'Misc',
    label: 'Pro Pools',
  },
};